export const mainColorPickers = {
  bg: {
    id: 'bgColor',
    spanClass: 'mainSpanMr-20',
    text: '背景顏色:',
    hasInputClass: true,
  },
  sys: {
    id: 'sysColor',
    spanClass: 'mainSpanMr-21',
    text: '系統顏色:',
  },
  btnGradientStart: {
    id: 'primaryBtnGradientStart',
    spanClass: 'mainSpanBold',
    text: '主按鈕漸層1:',
  },
  btnGradientEnd: {
    id: 'primaryBtnGradientEnd',
    spanClass: 'mainSpanBold',
    text: '主按鈕漸層2:',
  },
  btnTxt: {
    id: 'primaryBtnTxt',
    spanClass: 'spanMr-8',
    text: '主按鈕字體:',
  },
};

export const subColorPickers = {
  btnBg: {
    spanClass: 'spanMr-8',
    id: 'secondaryBtnBg',
    text: '次按鈕背景:',
  },
  btnTxt: {
    spanClass: 'subSpanTxtColor',
    id: 'secondaryBtnTxt',
    text: '次按鈕字體:',
  },
};

export const icons = [
  {
    label: '預設',
    value: '預設',
  },
  {
    label: '情人節',
    value: '情人節',
  },
  {
    label: '端午節',
    value: '端午節',
  },
  {
    label: '中秋節',
    value: '中秋節',
  },
  {
    label: '聖誕節',
    value: '聖誕節',
  },
  {
    label: '跨年',
    value: '跨年',
  },
  {
    label: '春節',
    value: '春節',
  },
];
